(function (app, ng) {

    function dateStatus() {
        return function (input) {
            var date = new Date(input);
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            return date >= today ? "Upcoming" : "Past";
        };
    }

    dateStatus.$inject = [];
    app.filter("dateStatus", dateStatus);

})(window.app, window.angular); //jshint ignore:line